import { render, staticRenderFns } from "./ExtratoReceitasDiversas.vue?vue&type=template&id=313ff9b8&scoped=true&"
import script from "./ExtratoReceitasDiversas.vue?vue&type=script&lang=js&"
export * from "./ExtratoReceitasDiversas.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoReceitasDiversas.vue?vue&type=style&index=0&id=313ff9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ff9b8",
  null
  
)

export default component.exports